var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.filledPortals),function(portal){return _c('portal',{key:portal,attrs:{"to":`pcHeading_${portal}`}},[_vm._t(portal)],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }